import { Button, Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomSortIconBig from '../../../components/CustomSortIconBig/CustomSortIconBig';
import { useSelector } from 'react-redux';
import { numberWithSpacesInter } from '../../../helpers/formatInteger';
import { getClassCategoryArrayColor } from '../../../hooks/getClassCategoryArrayColor';
import CustomProgres from '../../../components/CustomProgres/CustomProgres';

const ClientAssets = ({ selectedPortfolio, cashes, currencyList }) => {
  const [tabs, setTabs] = useState(0);
  const { t } = useTranslation('');

  const { assets } = useSelector((state) => state.instrumentsReducer);

  const sorterArray = {
    descend: 1,
    ascend: -1,
  };

  const [sort, setSort] = useState('descend');

  const [asseCategoryData, setAsseCategoryData] = useState(null);

  useEffect(() => {
    console.log('asseCategoryData', asseCategoryData);
    
  }, [asseCategoryData]);
  

  useEffect(() => {
    if (selectedPortfolio && cashes) {
      const data = getClassCategoryArrayColor(
        selectedPortfolio,
        cashes,
        assets,
      );
      setAsseCategoryData(data);
    }
  }, [selectedPortfolio, cashes, currencyList]);

  const handleTabs = () => {
    setTabs(tabs ? 0 : 1);
    setSort('descend');
  };

  return (
    <div className="class-side-wrap">
      <Row
        justify={'space-between'}
        className="asset-category-header-wrap"
        style={{ padding: '24px' }}
      >
        <Col>
          <Button
            type="text"
            className={`portfolio-tabs-btn ${tabs === 0 ? 'selected' : ''}`}
            onClick={handleTabs}
          >
            {t('CATEGORY')}
          </Button>
          <Button
            type="text"
            className={`portfolio-tabs-btn ${tabs === 1 ? 'selected' : ''}`}
            onClick={handleTabs}
          >
            {t('CLASS')}
          </Button>
        </Col>
        <Col>
          <CustomSortIconBig sortOrder={sort} setSort={setSort} />
        </Col>
      </Row>
      {tabs === 0 &&
        asseCategoryData?.category
          ?.sort((a, b) => (b.weight - a.weight) * sorterArray[sort])
          ?.map((item) => (
            <React.Fragment key={item.name + '_category'}>
              <div className="client table-wrapper">
                <div className="table-date-row">
                  <div>
                    <p className="table-date-name">
                      {item.name?.toUpperCase()}
                    </p>
                    <p className="table-date-value">{`${numberWithSpacesInter(item.value, 0)} kr`}</p>
                  </div>
                  <div className="table-date-persent">
                    {numberWithSpacesInter(item.weight, 2)}%
                  </div>
                </div>
                <CustomProgres
                  size={{ height: '3px' }}
                  segments={item.segments}
                />
                {/* <Progress
                  className="table-date-progress"
                  percent={item.weight.toFixed(2)}
                  showInfo={false}
                  strokeColor={'#FB7B34'}
                  size={{ height: 2 }}
                /> */}
              </div>
            </React.Fragment>
          ))}
      {tabs === 1 &&
        asseCategoryData?.class
          ?.sort((a, b) => (b.weight - a.weight) * sorterArray[sort])
          ?.map((item) => (
            <React.Fragment key={item.name + '_class'}>
              <div className="client table-wrapper">
                <div className="table-date-row">
                  <div>
                    <p className="table-date-name">
                      {item.name?.toUpperCase()}
                    </p>
                    <p className="table-date-value">{`${numberWithSpacesInter(item.value, 0)} kr`}</p>
                  </div>
                  <div className="table-date-persent">
                    {numberWithSpacesInter(item.weight, 2)}%
                  </div>
                </div>
                <CustomProgres
                  size={{ height: '3px' }}
                  segments={item.segments}
                />
                {/* <Progress
                  className="table-date-progress"
                  percent={item.weight.toFixed(2)}
                  showInfo={false}
                  strokeColor={'#FB7B34'}
                  size={{ height: 2 }}
                /> */}
              </div>
            </React.Fragment>
          ))}
    </div>
  );
};

export default ClientAssets;
ClientAssets.propTypes = {
  selectedPortfolio: PropTypes.array,
  cashes: PropTypes.array,
  currencyList: PropTypes.array,
};
